import React from 'react';

type Props = {
    type?       : 'default' | 'normal' | 'default-small' | 'small'
    color?      : 'red' | 'grey'
    onClick?    : callback
    className?  : string
};

export default function DeleteButton(props: Props) {

    const type      = props.type || 'default'
    const color     = props.color || 'red'

    const classes = Classes("gd-button-remove", "i5-delete-circle-solid",
        `${type}-type`,
        `${color}-color`,
        props.className
    );

    return <div className={classes} onClick={props.onClick} />;
}
//
//
// export default function DeleteButton extends BaseComponent {
//
//     static propTypes = {
//         type: PropTypes.oneOf(['default','normal','default-small','small']),
//         color: PropTypes.oneOf(['red','grey']),
//         onClick: PropTypes.func
//     };
//
//     static defaultProps = {
//         type: 'default',
//         color: 'red'
//     };
//
//     constructor(props) {
//         super(props);
//     }
//
//     render() {
//
//         const classes = Classes(
//             "gd-button-remove", "i5-delete-circle-solid",
//             this.props.type+"-type",
//             this.props.color+"-color",
//             this.props.className
//         )
//
//         return <div className={classes} onClick={this.props.onClick} />
//     }
// }